import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {  ChevronUp, ChevronDown, Mail } from "lucide-react";
import ReCAPTCHA from "react-google-recaptcha";
import { Icon } from "@iconify/react";

export default function Footer() {
	const [openMenu, setOpenMenu] = useState(null);
	
	const [footerData, setFooterData] = useState({});
	const [email, setEmail] = useState("");
	const [emailError, setEmailError] = useState("");
	const [subscribeMessage, setSubscribeMessage] = useState(null);
	const [capVal, setCapVal] = useState(null);
	const [status, setStatus] = useState(null);
	const [showRecaptcha, setShowRecaptcha] = useState(false);



	useEffect(() => {
		const fetchProducts = async () => {
			try {
				const response = await fetch(
					`https://admin.monsinidress.com/api/navbar`,
					{
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ brand: "Risky" }),
					}
				);

				if (!response.ok) {
					throw new Error("Failed to fetch products");
				}
				const productsData = await response.json();

				const rawData = productsData.data || {};
				const formattedData = {};
				Object.keys(rawData).forEach((category) => {
					const categoryData = rawData[category];
					const years = categoryData?.years || [];
					const sizeChartImage = categoryData?.sizeChartImage || null;
					const sortedYears = [...years].sort((a, b) => b - a);
					formattedData[category] = {
						years: sortedYears,
						sizeChartImage: sizeChartImage,
					};
				});

				setFooterData(formattedData);
			} catch (err) {
				console.error("Error fetching footer data:", err);
				setFooterData({});
			}
		};

		fetchProducts();
	}, []);

	const toggleMenu = (menu) => {
		setOpenMenu(openMenu === menu ? null : menu);
	};





	const getDropdownClasses = (menuName) => {
		const baseClasses =
			"ml-4 mt-2 flex flex-col gap-1 overflow-hidden transition-all duration-300 ease-in-out";
		const isOpen = openMenu === menuName;
		const heightClass = isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0";
		return `${baseClasses} ${heightClass}`;
	};

	// Helper function to generate route path
	const getCategoryRoute = (categoryName, year) => {
		const routeMap = {
			Gowns: "gowns",
			Prom: "prom",
			Bridal: "bridal",
			Evening: "evening",
		};

		const baseRoute = routeMap[categoryName] || categoryName.toLowerCase();
		return `/${baseRoute}/${year}`;
	};

	const handleSubscribe = async () => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		setEmailError("");
		setSubscribeMessage(null);
		setStatus(null);

		if (!email) {
			setEmailError("Email is required");
			return;
		} else if (!emailRegex.test(email)) {
			setEmailError("Please enter a valid email address");
			return;
		}

		if (!showRecaptcha) {
			setShowRecaptcha(true);
			return;
		}

		if (!capVal) {
			setStatus("recaptcha-error");
			return;
		}

		try {
			const payload = {
				brandName: "Risky",
				email: email,
			};

			const response = await fetch(
				`https://admin.monsinidress.com/api/subscriber`,
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(payload),
				}
			);

			if (!response.ok) {
				console.log(response);
				const errorData = await response
					.json()
					.catch(() => ({ message: "Subscription failed." }));
				throw new Error(
					errorData.message || "Subscription failed. Please try again."
				);
			}

			setEmailError("");
			setSubscribeMessage("Thank you for subscribing! Check your inbox.");
			setEmail("");
			setCapVal(null);
			setShowRecaptcha(false);
			setStatus(null);
			setTimeout(() => setSubscribeMessage(null), 4000);
		} catch (error) {
			console.error("Subscription API Error:", error);
			setSubscribeMessage(
				error.message || "An unknown error occurred during subscription."
			);
			setTimeout(() => setSubscribeMessage(null), 5000);
		}
	};



	return (
		<>
			

			{/* Custom Subscription Message */}
			{subscribeMessage && (
				<div
					className={`fixed bottom-4 right-4 text-white p-3 rounded-lg shadow-xl z-[1202] flex items-center gap-2 ${
						subscribeMessage.includes("failed") ? "bg-red-600" : "bg-green-500"
					}`}>
					<Mail className="w-5 h-5" />
					{subscribeMessage}
				</div>
			)}

			{/* FOOTER */}
			<div className="w-full bg-[#8a459f] overflow-x-hidden">
				<div className="w-full md:px-10 px-6 lg:px-16 grid lg:grid-cols-4 md:grid-cols-2 gap-5 border-b">
					{/* Newsletter */}
					<div className="flex justify-center items-start text-white flex-col lg:px-10 md:px-4 md:py-2 lg:py-6">
						<h2 className="text-3xl font-lora my-4">Let's get in Touch</h2>
						<p className="font-poppins text-[14px]">
							Sign up for our newsletter and get news about latest products and
							discounts
						</p>

						<input
							type="text"
							placeholder="Enter Your Email Address..."
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className="text-white placeholder:text-white font-poppins px-3 w-full outline-none border-2 bg-inherit text-[16px] py-2 rounded-lg my-2 border-white hover:bg-white hover:bg-opacity-25 transition-all duration-300 focus:bg-white focus:bg-opacity-25"
						/>
						{emailError && (
							<p className="text-white text-sm bg-red-600 p-1 rounded mt-1">
								{emailError}
							</p>
						)}

						{/* CORRECTED: ReCAPTCHA Integration */}
						{showRecaptcha && (
							<div>
								<ReCAPTCHA
									// sitekey="6LdOLCAsAAAAAAknRv5DDE5SRlHV6mBnBuKkdkuC"
									sitekey="6LcikiksAAAAAD6Pjibn5bvNJyYBPj1EMym0ryw7"
									onChange={(val) => setCapVal(val)}
								/>
								{status === "recaptcha-error" && (
									<p className="mt-2 text-sm text-red-600 font-medium">
										Please complete the reCAPTCHA verification
									</p>
								)}
							</div>
						)}

						<button
							onClick={handleSubscribe}
							className="mt-4 bg-white text-[#1f4c94] font-semibold py-1.5 px-4 rounded hover:bg-opacity-90 transition w-full">
							{showRecaptcha ? "Complete Subscription" : "Subscribe"}
						</button>
					</div>

					{/* Dynamic Dropdowns */}
					<div className="text-white font-Jost-Regular md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Collections
						</h2>

						{Object.keys(footerData).length === 0 ? (
							// Default Fallback: Show 'Gowns' dropdown with Size Chart button
							<div key="gowns-default" className="font-poppins">
								<button
									onClick={() => toggleMenu("gowns")}
									className="flex justify-between items-center w-full py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
									<span>Gowns</span>
									<span>
										{openMenu === "gowns" ? <ChevronUp /> : <ChevronDown />}
									</span>
								</button>
								<div className={getDropdownClasses("gowns")}>
									{/* Always show Size Chart button */}
									<Link
										to="/size-chart/gowns"
										className="py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-3 w-full text-left">
										Size Chart
									</Link>
								</div>
							</div>
						) : (
							// Original Logic: Map through footerData
							Object.keys(footerData).map((cleanCategoryName) => {
								const menuKey = cleanCategoryName
									.replace(/\s+/g, "")
									.toLowerCase();
								const yearsList = footerData[cleanCategoryName].years;
								const hasYears = yearsList && yearsList.length > 0;

								return (
									<div key={cleanCategoryName} className="font-poppins">
										<button
											onClick={() => toggleMenu(menuKey)}
											className="flex justify-between items-center w-full py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
											<span>{cleanCategoryName}</span>
											<span>
												{openMenu === menuKey ? <ChevronUp /> : <ChevronDown />}
											</span>
										</button>
										<div className={getDropdownClasses(menuKey)}>
											{/* Show years only if they exist */}
											{hasYears &&
												yearsList.map((year) => (
													<Link
														key={year}
														to={getCategoryRoute(cleanCategoryName, year)}
														className="py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-3 block">
														{year} Collection
													</Link>
												))}
											{/* Always show Size Chart button */}
											<Link
												to={`/size-chart/${cleanCategoryName.toLowerCase()}`}
												className="py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-3 w-full text-left">
												Size Chart
											</Link>
										</div>
									</div>
								);
							})
						)}
					</div>

					{/* Contact Section */}
					<div className="text-white font-Jost-Regular md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Contact Links
						</h2>
						<p className="font-poppins">
							<Link
								to="/about"
								className="block py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								About Us
							</Link>
						</p>
						<p className="font-poppins">
							<Link
								to="/contact"
								className="block py-1 px-2 rounded transition-all duration-300 hover:bg-white hover:bg-opacity-25 hover:px-2">
								Contact Us
							</Link>
						</p>
						<p className=" border-[1px] border-white rounded-md w-fit p-2">
							<Link
								to="https://market.riskydress.com/"
								className="flex items-center gap-1 text-white hover:text-gray-300 transition">
								<Icon icon="qlementine-icons:user-16" width="20" height="20" />
								<span className="text-sm font-medium">RETAILER LOGIN</span>
							</Link>
						</p>
					</div>

					{/* Social Section */}
					<div className="text-white md:px-5 lg:px-5 flex flex-col gap-2 py-6 md:py-10 lg:py-14">
						<h2 className="font-lora mb-2 font-medium text-[20px]">
							Social Links
						</h2>
						<p className="font-poppins hover:bg-white hover:bg-opacity-25 py-1 px-2 rounded transition-all duration-300 cursor-default">
							Info@RiskyDress.com
						</p>
						<p className="font-poppins hover:bg-white hover:bg-opacity-25 py-1 px-2 rounded transition-all duration-300 cursor-default">
							450-818-7078
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
